// /src/context/ThemeContext.js
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const ThemeContext = createContext({
  theme: 'light',
  isDark: false,
  setTheme: () => {},
  toggleTheme: () => {},
});

export const ThemeProvider = ({ initial = 'dark', children }) => {
  const [theme, setTheme] = useState(() => {
    if (typeof window === 'undefined') return initial || 'dark';
    return window.localStorage.getItem('theme') || initial || 'dark';
  });

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.classList.toggle('dark', theme === 'dark');
    }
    window.localStorage.setItem('theme', theme);
    window.dispatchEvent(new CustomEvent('app:theme', { detail: theme }));
  }, [theme]);

  const value = useMemo(() => ({
    theme,
    isDark: theme === 'dark',
    setTheme,
    toggleTheme: () => setTheme(prev => (prev === 'dark' ? 'light' : 'dark')),
  }), [theme]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
